import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_statistic = (startDate = null, endDate = null) => {
  let url = `${ApiEndpointConstants.STATISTIC}`;
  const params = [];

  if (startDate) {
    params.push(`start_date=${encodeURIComponent(startDate)}`);
  }
  if (endDate) {
    params.push(`end_date=${encodeURIComponent(endDate)}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return api.get(url);
};
